// An Amazon Connect flow cannot clear a contact attribute, so it writes "null" when there is no intent interaction
const NO_INTENT_INTERACTION_VALUE = 'null';

export const getIntentInteractionId = (contact: connect.Contact): string | undefined => {
  const value = contact.getAttributes().intent_interaction_id?.value;
  return value === NO_INTENT_INTERACTION_VALUE ? undefined : value;
};
